package one.healthium

expect class Platform {
    val filesDir: String
    val cacheDir: String
    val deviceInfo: DeviceInfo
}

data class DeviceInfo(
    val device: String,
    val deviceFamily: String,
    val os: String,
    val osVersion: String,
    val language: String,
    val fontScaleFactor: Float,
)